class AgeVerification extends HTMLElement {
  constructor() {
    super();

    // Buttons
    this.accept_button = this.querySelector(".age-verification--accept");
    this.decline_button = this.querySelector(".age-verification--decline");
    this.return_button = this.querySelector(".age-verification--return");

    // Views
    this.primary_view = this.querySelector(".age-verification--primary");
    this.secondary_view = this.querySelector(".age-verification--secondary");

    // Scroll & localStorage key
    this.scrollY = 0;
    this.storageKey = "impact_age_verification";
  }

  connectedCallback() {
    this.bindEvents();

    const accepted = localStorage.getItem(this.storageKey);

    if (!accepted || Shopify.designMode) {
      this.open();
    }
  }

  bindEvents() {
    this.accept_button?.addEventListener("click", () => this.accept());
    this.decline_button?.addEventListener("click", () => this.showSecondary());
    this.return_button?.addEventListener("click", () => this.showPrimary());

    if (Shopify.designMode) {
      document.addEventListener("shopify:section:select", () => this.open());
      document.addEventListener("shopify:section:deselect", () => this.close());
    }
  }

  open() {
    this.scrollY = window.scrollY;

    // Lock scroll
    const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
    if (scrollBarWidth > 0) {
      document.body.style.paddingRight = `${scrollBarWidth}px`;
    }

    document.body.style.position = "fixed";
    document.body.style.top = `-${this.scrollY}px`;
    document.body.style.width = "100%";
    document.body.style.overflow = "hidden"; // prevent scroll while open

    this.setAttribute("aria-hidden", "false");
    this.setAttribute("data-transition-active", "true");
  }

  close() {
    // Unlock scroll
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.width = "";
    document.body.style.paddingRight = "";
    document.body.style.overflow = "auto"; // restore scrollbar

    window.scrollTo(0, this.scrollY);

    localStorage.setItem(this.storageKey, "true");

    this.setAttribute("data-transition-active", "false");
    this.setAttribute("aria-hidden", "true");
  }

  accept() {
    this.close();
  }

  // Show secondary view with fade
  showSecondary() {
    this.setAttribute("data-view", "secondary");
  }

  // Show primary view with fade
  showPrimary() {
    this.removeAttribute("data-view");
  }
}

customElements.define("age-verification", AgeVerification);
